// src/utils/plateTypeDB.js
// IndexedDB utility for storing platetypes
// Fields: boardname, screenSize, ramSize, flashSize, psRamSize, primaryColor, secondaryColor, uiTheme

const DB_NAME = 'PlateTypesDB';
const STORE_NAME = 'platetypes';
const DB_VERSION = 1;

export const plateTypeStruct = {
    boardname: 'Change name',
    title: 'Use size in title',
    screenSize: { width: 240, height: 320 },
    shape: 'rectangular',
    ramSize: 512,
    flashSize: 1024,
    psRamSize: 0,
    primary_color: '#00b6ff',
    secondary_color: '#ff9962',
    uiTheme: '5'
}

function openDB() {
    return new Promise((resolve, reject) => {
        const request = indexedDB.open(DB_NAME, DB_VERSION);
        request.onupgradeneeded = (event) => {
            const db = event.target.result;
            let store;
            if (!db.objectStoreNames.contains(STORE_NAME)) {
                store = db.createObjectStore(STORE_NAME, { keyPath: 'boardname' });
            } else {
                store = event.target.transaction.objectStore(STORE_NAME);
            }
            // Preload default platetypes
            const defaultPlateTypes = [
                { boardname: "small_landscape", screenSize: { width: 320, height: 240 }, title: "Small 320x240" },
                { boardname: "small_portrait", screenSize: { width: 240, height: 320 }, title: "Small Portrait 240x320" },
                { boardname: "large_landscape", screenSize: { width: 480, height: 320 }, title: "Large Landcape 480x320" },
                { boardname: "large_portrait", screenSize: { width: 320, height: 480 }, title: "Large Portrait 320x480" },
                { boardname: "large_square", screenSize: { width: 480, height: 480 }, title: "Large Square 480x480" },
                { boardname: "7inch_landscape", screenSize: { width: 800, height: 480 }, title: "7\" Landcape 800x480" },
                { boardname: "7inch_portrait", screenSize: { width: 480, height: 800 }, title: "7\" Portrait 480x800" },
                { boardname: "xlarge_landscape", screenSize: { width: 800, height: 600 }, title: "X-large Landcape 800x600" },
                { boardname: "xlarge_portrait", screenSize: { width: 600, height: 800 }, title: "X-Large Portrait 600x800" }
            ];
            defaultPlateTypes.forEach(pt => {
                // create a new platetype based on plateTypeStruct
                const newPlateType = { ...plateTypeStruct, ...pt };
                store.add(newPlateType);
            });
        };
        request.onsuccess = () => resolve(request.result);
        request.onerror = () => reject(request.error);
    });
}

export async function addPlateType(plate) {
    const db = await openDB();
    return new Promise((resolve, reject) => {
        const tx = db.transaction(STORE_NAME, 'readwrite');
        const store = tx.objectStore(STORE_NAME);
        const req = store.add(plate);
        req.onsuccess = () => resolve(true);
        req.onerror = () => reject(req.error);
    });
}

export async function getPlateType(boardname) {
    const db = await openDB();
    return new Promise((resolve, reject) => {
        const tx = db.transaction(STORE_NAME, 'readonly');
        const store = tx.objectStore(STORE_NAME);
        const req = store.get(boardname);
        req.onsuccess = () => resolve(req.result);
        req.onerror = () => reject(req.error);
    });
}

export async function getAllPlateTypes() {
    const db = await openDB();
    return new Promise((resolve, reject) => {
        const tx = db.transaction(STORE_NAME, 'readonly');
        const store = tx.objectStore(STORE_NAME);
        const req = store.getAll();
        req.onsuccess = () => resolve(req.result);
        req.onerror = () => reject(req.error);
    });
}

export async function updatePlateType(plate) {
    const db = await openDB();
    return new Promise((resolve, reject) => {
        const tx = db.transaction(STORE_NAME, 'readwrite');
        const store = tx.objectStore(STORE_NAME);
        const req = store.put(plate);
        req.onsuccess = () => resolve(true);
        req.onerror = () => reject(req.error);
    });
}

export async function deletePlateType(boardname) {
    const db = await openDB();
    return new Promise((resolve, reject) => {
        const tx = db.transaction(STORE_NAME, 'readwrite');
        const store = tx.objectStore(STORE_NAME);
        const req = store.delete(boardname);
        req.onsuccess = () => resolve(true);
        req.onerror = () => reject(req.error);
    });
}

// Example plate object:
// {
//   boardname: 'myboard',
//   screenSize: '800x480',
//   ramSize: 8,
//   flashSize: 16,
//   psRamSize: 4,
//   primaryColor: '#ff0000',
//   secondaryColor: '#00ff00',
//   uiTheme: 'dark'
// }
